import { addScript } from '@tunein/web-utils';
import assign from 'lodash/assign';
import { DISCORD_PAL_SCRIPT, PAL_SCRIPT, PAL_SCRIPT_ID, } from '../ads/constants';
import { PAL_NONCE_GENERATOR_ERROR, PAL_REPORTING_ERROR, } from '../logging/constants';
import logger from '../logging/logger';
import { State, getState } from '../utils/applicationState';
const requestOptions = {
    adWillAutoPlay: true,
    adWillPlayMuted: false,
    continuousPlayback: true,
    descriptionUrl: 'https%3A%2F%2Ftunein.com',
    iconsSupported: false,
    playerType: 'web',
    playerVersion: '3.0',
    adTypes: [],
};
export const palSdkController = {
    init() {
        this.handleNonceError = this.handleNonceError.bind(this);
        this.getNonce = this.getNonce.bind(this);
        this.report = this.report.bind(this);
        this.loadScript();
    },
    async getNonce() {
        await this.scriptLoaderPromise;
        return await this.generateNonce();
    },
    loadScript() {
        const isInDiscordIFrame = getState(State.isInDiscordIFrame);
        this.scriptLoaderPromise = new Promise(async (res) => {
            this.resolveScriptLoaderPromise = res;
            try {
                await addScript({
                    src: isInDiscordIFrame ? DISCORD_PAL_SCRIPT : PAL_SCRIPT,
                    id: PAL_SCRIPT_ID,
                });
                this.initNonceLoader();
            }
            catch (e) {
            }
        });
    },
    initNonceLoader() {
        try {
            this.nonceLoader = new goog.pal.NonceLoader();
        }
        catch (error) {
            this.handleNonceError(error, 'Error during Google PAL NonceLoader initialization.');
        }
        this.resolveScriptLoaderPromise();
    },
    async generateNonce() {
        try {
            const nonceRequest = this.generateNonceRequest();
            this.nonceManager = await this.loadNonceManager(nonceRequest);
            return this.nonceManager.getNonce();
        }
        catch (error) {
            this.handleNonceError(error);
            return '';
        }
    },
    generateNonceRequest() {
        const nonceRequest = new goog.pal.NonceRequest();
        nonceRequest.ppid = getState(State.ppid);
        return assign(nonceRequest, requestOptions);
    },
    loadNonceManager(nonceRequest) {
        return this.nonceLoader
            .loadNonceManager(nonceRequest)
            .catch(this.handleNonceError);
    },
    handleNonceError(error, message) {
        logger.debug(message || 'Error during Google PAL nonce generation.', error);
        logger.error({
            message: PAL_NONCE_GENERATOR_ERROR,
            error: error,
        });
    },
    report(type) {
        try {
            this.nonceManager[`sendAd${type}`]();
        }
        catch (error) {
            this.handleReportingError(error);
        }
    },
    handleReportingError(error) {
        logger.debug('Error reporting Google PAL action.', error);
        logger.error({
            message: PAL_REPORTING_ERROR,
            error: error,
        });
    },
};
export default {
    init() {
        palSdkController.init.call(palSdkController);
    },
    async getNonce() {
        try {
            return await palSdkController.getNonce();
        }
        catch (e) {
            return '';
        }
    },
    reportAdImpression() {
        palSdkController.report('Impression');
    },
    reportAdClick() {
        palSdkController.report('Click');
    },
};
